import { useContext } from 'react';
import type { PermissionKey } from '../../lib/rbac/permissions.generated';
import type { CanOptions } from '../../lib/rbac/permissions';
import { PermissionContext } from './permission-context';

export const usePermissions = () => {
  const context = useContext(PermissionContext);
  if (context === undefined) {
    throw new Error('usePermissions must be used within a PermissionProvider');
  }
  return context;
};

/** True, wenn der Server den Key (bedingungslos bzw. mit behandelter Condition) liefert. */
export const usePermission = (key: PermissionKey, options?: CanOptions): boolean => {
  const { status, can } = usePermissions();
  return status === 'ready' && can(key, options);
};
